<template lang="pug">
	.audio-track-sub-tracks-filter-panel(v-if="isVisible")
		.flex-row.space.align-center.nowrap.justify.full-height
			DxTextBox(:value.sync="filterString", width="80" :placeholder="$tCaption('Search', '@actions')")
			.right.flex-row.align-center.space
				.center-aligned
					.flex-row.space.align-center.pages
						span {{ $tCaption('Page') }}
						DxNumberBox(:value="track.__skipPages + 1", width="80", :max="totalPages", :min="1", @valueChanged="onSkipValueChanged", stylingMode="filled", :width="30", :hint="`${track.__skipPages + 1}`")
						span {{ $tCaption('/ TOTAL').replace(/TOTAL/g, totalPages) }}
</template>

<script>
	import DxTextBox from 'devextreme-vue/text-box';
	import DxNumberBox from 'devextreme-vue/number-box';

	export default {
		translationCategory: 'audioTracker.AudioTrackInfoPanel',
		name: 'audio-track-info',
		props: ['track', 'aggregatedTrack'],
		components: {
			DxTextBox,
			DxNumberBox
		},
		data() {
			return {
				filterString: this.track.__subTracksSearchString
			};
		},
		computed: {
			isVisible() {
				return this.track?.__totalSubInsertions > this.track?.__tracker?.subTracksVisibleLimit;
			},
			totalPages() {
				return Math.max(1, Math.floor(this.track?.__totalFilteredSubInsertions / this.track?.__tracker?.subTracksVisibleLimit));
			},
			format() {
				return this.$tCaption('Page PAGE_NUM of TOTAL_PAGES').replace('PAGE_NUM', '#0').replace('TOTAL_PAGES', `'${this.totalPages}'`);
			}
		},
		watch: {	
			filterString(v)	{
				this.aggregatedTrack.__tracks.map(track => track.__subTracksSearchString = v);
			}
		},
		mounted() {			
		},
		destroyed() {			
		},
		methods: {
			onSkipValueChanged(e) {
				this.aggregatedTrack.__tracks.map(track => {
					var delta = (e.value - 1) - track.__skipPages;
					if (track.addSubTracksSkip(delta * track?.__tracker?.subTracksVisibleLimit)) {
						track.__tracker.updateTracksList(true);
					}
				});
			}
		}
	};
</script>
<style lang='scss'>
	.audio-track-sub-tracks-filter-panel {
		@import "main/themes/generated/variables.base.scss";
		
		border-top: 1px solid rgba(0,0,0,0.05);
		padding: 2px 8px;
		height: 30px;
		width: 100%;
		background: rgba(0,0,0,0.025);
		
		.dx-texteditor-container {
			.dx-texteditor-input, .dx-placeholder::before {
				padding: 2px 0 2px !important;
				font-size: 11px !important;
			}

			.dx-placeholder {
				font-size: 11px !important;
			}
		}

		.dx-texteditor.dx-editor-underlined::after {
			border-bottom: 1px solid rgb(0, 0, 0, 0.07) !important;
		}

		.center-aligned {
			.dx-texteditor-input {
				text-align: center;
			}
		}

		.pages {
			font-size: 10px;
			letter-spacing: -0.25px;
		}
	}
</style>
